import { oc } from '@orpc/contract';
import { loginInputSchema, tokensOutputSchema } from '../schemas/auth.schemas.js';
export const loginUserContract = oc
    .route({
    method: 'POST',
    path: '/auth/login',
    tags: ['Auth'],
    summary: 'Exchange email and password for an access/refresh token pair',
})
    .input(loginInputSchema)
    .output(tokensOutputSchema);
//# sourceMappingURL=login-user.contract.js.map